let clearer = false

export default {
  showErrorMessage ({ commit }, error, duration = 2000) {
    console.log(error, error.response, typeof (error))
    if (typeof (error) === 'string') { commit('errorMessage', error) } else if (error.response.data.message) {
      let errorMessage = error.response.data.message
      const errors = error.response.data.errors && Object.values(error.response.data.errors)
      if (errors)
        for (let i = 0; i < errors.length; i++)
          errorMessage += `<br>${errors[i]}`
      commit('errorMessage', errorMessage)
    } else { commit('errorMessage', error.response.data) }

    clearTimeout(clearer)
    clearer = setTimeout(() => {
      commit('errorMessage', false)
    }, duration)
  },
  showSuccessWindow ({ commit }) {
    commit('showSuccessWindow', true)
    clearTimeout(clearer)
    clearer = setTimeout(() => {
      commit('showSuccessWindow', false)
    }, 1000)
  }
}
